import { Divider, Flex } from '@bitrise/bitkit';
import React, { FunctionComponent } from 'react';

const CrashReportDivider: FunctionComponent = () => (
  <Flex paddingHorizontal="x8">
    <Divider color="gray-2" width="1px" />
  </Flex>
);

export default CrashReportDivider;
